var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsavulLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0622 29.1838L16.1144 30.5839L28.0271 8.41406L15.0476 28.8093C14.9739 28.925 14.9798 29.0742 15.0622 29.1838Z",
    fill: "#0C0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0293 8.41406L11.6152 24.0128C11.4697 24.1511 11.4509 24.3761 11.5715 24.5365L13.9756 27.7365L14.017 26.1703C14.0193 26.0847 14.0494 26.0021 14.1027 25.9349L28.0293 8.41406Z",
    fill: "#0C0C0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0293 8.41406L6.75887 17.1724C6.47949 17.2875 6.38396 17.6347 6.56531 17.8759L9.77396 22.1463L10.0497 20.5533C10.0712 20.4285 10.1433 20.3181 10.2488 20.2479L28.0293 8.41406Z",
    fill: "#0C0C0C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0271 8.41406H0.554855C0.119492 8.41434 -0.160343 8.9293 0.100838 9.27686L3.9854 14.4464L4.48164 13.1582C4.54725 12.9881 4.69627 12.8637 4.87576 12.8295L28.0271 8.41406Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsavulLogo);
export default __webpack_public_path__ + "static/media/osavulLogo.119c3f378b2a9d682e64f44c0b08f772.svg";
export { ForwardRef as ReactComponent };